
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';

//Components
import { Grid } from "@mui/material";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Form,
    Select,
} from "@gpstrackit/react-controls";
import CustomCard from 'Components/Card';
import CustomSelect from 'Components/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';

//Notification
import { NotificationManager } from "Components/Notifications";
import { getAccounts } from '../../../activities/views/main/redux/saga'

//Actions
import {
    bulkTagsGetDeviceRequest,
    searchEntityRequest,
    bulkTagsSetDevice,
    bulkTagsRequest,
    clearRedux,
} from 'Redux/actions';
import en from "./lan/en";
import { set } from "lodash";

const bulkTags = (props) => {
    const formRef = useRef(null);
    const formTwoRef = useRef(null);
    const { messages } = useIntl();
    const { tableRef, single, getDevice, entityName } = props;
    const dispatch = useDispatch();

    //Redux States
    const { device, loading, openModal, result, devices, selectedDevices } = useSelector(state => state.bulkTagsRedux)
    const { tags } = useSelector(state => state.generalRedux);

    //Local States
    const [serial, setSerial] = useState("");
    const [step, setStep] = useState(1);
    const [selectedTags, setSelectedTags] = useState([]);
    const [account, setAccount] = useState(null);
    const [assign, setAssign] = useState(true);

    const searchDevice = () => {
        dispatch(bulkTagsGetDeviceRequest({ openSearch: serial?.trim(), entityName: entityName }));
    }

    const closeModal = () => {
        setSerial("");
        setStep(1);
        setSelectedTags([]);
        dispatch(clearRedux("BULK_TAGS"));
    }

    const applyChanges = () => {
        let unitIds = devices.map((item) => (item?.id))
        let payload = {
            entityName: entityName,
            tagIds: selectedTags?.map((item) => (item?.id)) || [],
            entityIds: unitIds,
            action: assign ? "assign" : "unassign"
        }
        dispatch(bulkTagsRequest(payload))
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    useEffect(() => {
        if (device) {
            if (!device?.total) {
                NotificationManager.warning(
                    messages['bulk_tags_device_has_not_been_found'],
                    messages['bulk_tags_title'],
                    3000
                );
            } else {
                let currentDevices = devices;
                let newDevice = device?.items[0];
                let validateNewDevice = currentDevices.some((item) => item.id === newDevice.id);
                if (!validateNewDevice) {
                    let validateGlobalStar = newDevice?.deviceModel?.manufacturer?.name !== "Global Star";
                    if (validateGlobalStar) currentDevices.push(newDevice);
                    setSerial("");
                    dispatch(bulkTagsSetDevice(currentDevices))
                } else {
                    setSerial("");
                    NotificationManager.warning(
                        messages['bulk_tags_device_is_already_added'],
                        messages['bulk_tags_title'],
                        3000
                    );
                }
            }
            dispatch(clearRedux("BULK_TAGS", { device: null }))
        }
        if (result?.assignBulkTags) {
            NotificationManager.success(
                messages['bulk_tags_multiple_success_message'],
                messages['bulk_tags_title'],
                3000
            );
            closeModal();
            getDevice && getDevice();
            tableRef && tableRef?.current?.getData();
        } else if (result && !result?.assignBulkTags) {
            NotificationManager.error(
                messages['bulk_tags_error_message'],
                messages['bulk_tags_title'],
                3000
            );
            dispatch(clearRedux("BULK_TAGS", { result: null }))
        }
        if (selectedDevices && selectedDevices.length > 0) {
            let newDevices = []
            if (entityName === "Unit")
                newDevices = selectedDevices.map((item) => ({ id: item?.id, imei: item?.imei, esn: item?.esn, deviceModel: item?.deviceModel }));
            else
                newDevices = selectedDevices

            dispatch(bulkTagsSetDevice(newDevices));
            dispatch(clearRedux("BULK_TAGS", { selectedDevices: [] }))
        }
    }, [device, result, selectedDevices])

    useEffect(() => {
        if (openModal) dispatch(searchEntityRequest({ key: "tags" }))
    }, [openModal])

    let validateStepOne = step === 1 && !single
    let validateStepTwo = step === 2 || single

    return (
        <Modal
            open={openModal}
            title={messages['bulk_tags_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                {
                    validateStepOne &&
                    <div style={{ padding: '0 10px', height: "600px" }}>
                        <Grid
                            container
                            spacing={1}
                        >
                            <Grid item xs={entityName === "Unit" ? 10 : 12}>
                                <Form
                                    ref={formRef}
                                    onValidSubmit={() => searchDevice()}
                                >
                                    {
                                        entityName === "Unit" &&
                                        <Input
                                            label={entityName === "Unit" ? messages['bulk_tags_input'] : messages['bulk_tags_input_company_name']}
                                            placeholder={entityName === "Unit" ? messages['bulk_tags_input'] : messages['bulk_tags_input_company_name']}
                                            value={serial}
                                            required
                                            requiredMessage={messages['required_field']}
                                            onChange={(value) => setSerial(value)}
                                        />
                                    }
                                    {
                                        entityName === "Company" &&
                                        <CustomSelect
                                            async
                                            value={account}
                                            onChange={(account) => {
                                                let currentDevices = devices;
                                                let validateNewDevice = currentDevices.some((item) => item.id === account.id);
                                                if (!validateNewDevice) {
                                                    currentDevices.push(account);
                                                    dispatch(bulkTagsSetDevice(currentDevices))
                                                } else {
                                                    NotificationManager.warning(
                                                        messages['bulk_tags_company_is_already_added'],
                                                        messages['bulk_tags_title'],
                                                        3000
                                                    );
                                                }

                                            }}
                                            label={messages['devices_import_account']}
                                            placeholder={messages["devices_import_account"]}
                                            loadOptions={getAccountsForSelect}
                                            getOptionLabel={e => e.name}
                                            getOptionValue={e => e.id}
                                            menuPlacement="bottom"

                                        />
                                    }
                                </Form>
                            </Grid>
                            {
                                entityName === "Unit" &&
                                <Grid item xs={2}>
                                    <div style={{ marginTop: 26 }}>
                                        <Button
                                            className="btn-dark-blue"
                                            onClick={() => formRef?.current?.submit()}
                                        >
                                            {messages['common_add']}
                                        </Button>
                                    </div>
                                </Grid>
                            }
                        </Grid>
                        {devices?.length > 0 ? devices.map((item, index) => {
                            return (
                                <CustomCard
                                    key={index}
                                    onClick={() => {
                                        let currentDevices = devices;
                                        let selected = currentDevices.findIndex((device) => device.id === item.id);
                                        if (selected > -1) currentDevices.splice(selected, 1);
                                        dispatch(bulkTagsSetDevice(currentDevices));
                                    }}
                                >
                                    {
                                        entityName === "Unit" &&
                                        <div style={{ display: 'grid' }}>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['bulk_tags_imei']}</label><span>{item.imei}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['bulk_tags_serial']}</label><span>{item.esn}</span>
                                            </div>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['bulk_tags_model']}</label><span>{item?.deviceModel?.name}</span>
                                            </div>
                                        </div>
                                    }
                                    {
                                        entityName === "Company" &&
                                        <div style={{ display: 'grid' }}>
                                            <div>
                                                <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['bulk_tags_company_name']}</label><span>{item?.name}</span>
                                            </div>
                                        </div>
                                    }
                                </CustomCard>
                            )
                        }) : <div style={{ display: 'flex', justifyContent: 'center', marginTop: 25 }} ><span style={{ opacity: 0.6 }} >{entityName === "Unit" ? messages['common_no_devices_added'] : messages['common_no_accounts_added']}</span></div>}
                    </div>
                }
                {
                    validateStepTwo &&
                    <div style={{ padding: '0 10px' }}>
                        <Form
                            ref={formTwoRef}
                            onValidSubmit={() => applyChanges()}
                        >
                            <Grid
                                container
                                spacing={1}
                            >
                                <Grid item xs={10}>
                                    <div className='filters-type'>
                                        <FormControlLabel
                                            value={true}
                                            control={<Radio onClick={() => {
                                                setAssign(true);

                                            }} checked={assign} color="primary" />}
                                            label={messages['bulk_tags_assign']}
                                            labelPlacement="end"
                                        />
                                        <FormControlLabel
                                            value="start"
                                            control={<Radio onClick={() => {
                                                setAssign(false);
                                            }} checked={!assign} color="primary" />}
                                            label={messages['bulk_tags_unassign']}
                                            labelPlacement="end"
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={10}>
                                    <Select
                                        id="list-new-tags"
                                        value={selectedTags || []}
                                        options={tags}
                                        label={messages['bulk_tags_label']}
                                        placeholder={messages['bulk_tags_label']}
                                        onChange={(item) => setSelectedTags(item)}
                                        valueField="id"
                                        textField="label"
                                        required
                                        requiredMessage={messages['required_field']}
                                        multiple
                                    />
                                </Grid>
                            </Grid>
                        </Form>
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                {step === 2 && !single &&
                    <Button
                        className="btn btn-cancel btn-gray"
                        onClick={() => setStep(1)}
                    >
                        {messages['common_back']}
                    </Button>
                }
                <Button
                    disabled={step === 1 && devices.length === 0}
                    className="btn-dark-blue"
                    onClick={() => {
                        if (single) formTwoRef?.current?.submit();
                        else {
                            if (step < 2) setStep(step + 1);
                            else formTwoRef?.current?.submit();
                        }
                    }}
                >
                    {step === 1 && !single ? messages['common_next'] : messages['bulk_tags_assign']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default bulkTags;